import { CustomizedPreLoader } from "styles";

const PreLoader = () => {

    return <CustomizedPreLoader />;
    
}

export default PreLoader;